import { useAppSelector } from "../../app/hooks";
import Card from "../Card";
import { motion } from "motion/react";
import { ROTATIONS } from "../../models/game";

import styles from "./DiscardPile.module.css";

export default function DiscardPile() {
  const discardPile = useAppSelector((state) => state.game.game.discardPile);

  return (
    <div className={styles.discardPile}>
      {discardPile.map((card, index) => {
        const rotation = index === 0 ? 0 : ROTATIONS[index % ROTATIONS.length];
        return (
          <motion.div layoutId={card.id} key={card.id}>
            <div
              style={{
                transform: `rotate(${rotation}deg)`,
              }}
            >
              <Card card={card} />
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
